import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React from 'react';
/**
 * This hooks returns true when user clicks outside of the physical DOM component
 * @param {object} ref Created with React.useRef() and passing it to both this hook and the component as ref={ref} prop
 * @param {boolean} setBackToFalseAfterTrue As we want to be able to use it event if the component is not mounted we
 *  can use it, so after returning true once, it will be set back to false so it can be used again for the same
 *  component without having to unmount it
 * @returns {boolean}
 */

function useClickOutside(ref) {
  var setBackToFalseAfterTrue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      clickedOutside = _React$useState2[0],
      setClickedOutside = _React$useState2[1];

  React.useEffect(function () {
    /** Sets it back to false so it can be reused * */
    if (setBackToFalseAfterTrue && clickedOutside) {
      setClickedOutside(false);
    }
    /** If clicked outside, sets clickedOutside as true * */


    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setClickedOutside(true);
      }
    }
    /** Mousedown equals mouse click * */


    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, clickedOutside, setBackToFalseAfterTrue]);
  return clickedOutside;
}

export default useClickOutside;